// Icons from: https://www.freepik.com/, https://www.flaticon.com/authors/ferdinand, https://www.flaticon.com/authors/vidyavidz, https://www.flaticon.com/authors/pixel-perfect
// Images from https://unsplash.com/

import { useState } from "react"
import Topbar from "./components/topbar/Topbar";
import Menu from "./components/menu/Menu"
import Contact from "./components/contact/Contact";
import Portfolio from "./components/portfolio/Portfolio";
import Testimonials from "./components/testimonials/Testimonials";
import Intro from "./components/intro/Intro"
import Works from "./components/works/Works"
import Stack from "./components/stack/Stack"
import "./App.scss"

function App() {

  const [menuOpen, setMenuOpen] = useState(false)

  return (
    <div className="app">
      <Topbar menuOpen={menuOpen} setMenuOpen={setMenuOpen}/>
      <Menu menuOpen={menuOpen} setMenuOpen={setMenuOpen}/>
      <div className="sections">
        <Intro/>
        <Portfolio/>
        <Works/>
        <Stack/>
        <Testimonials/>
        <Contact/>
      </div>
    </div>
  );
}

export default App;
